module.exports = __webpack_public_path__ + "img/file_todo.d5275f6b.svg";